<template>
  <div>
    <b-form-group
      :label="$lang.evidence"
      label-for="evidence"
      :label-cols="this.$config.form.labelCol"
    >
      <requiredComponent
        slot="label"
        :label="$lang.evidence_second_person"
        :rules="$v.evidence.$params"
      />
      <b-form-textarea
        id="evidence"
        type="text"
        v-model="$v.evidence.$model"
        :state="$v.evidence.$dirty ? !$v.evidence.$error : null"
        :autocomplete="$lang.evidence"
        :rows="this.$config.form.textareaRows"
      ></b-form-textarea>
      <b-form-invalid-feedback id="father_name-feedback"
        >{{ $lang.error_required | replace($lang.evidence_second_person) }}
      </b-form-invalid-feedback>
    </b-form-group>

    <b-form-group
      :label="$lang.caption_third_person"
      label-for="evidence"
      :label-cols="this.$config.form.labelCol"
    >
      <requiredComponent
        slot="label"
        :label="$lang.evidence_caption_third_person"
        :rules="$v.caption_third_person.$params"
      />
      <b-form-textarea
        id="evidence"
        type="text"
        v-model="$v.caption_third_person.$model"
        :state="
          $v.caption_third_person.$dirty
            ? !$v.caption_third_person.$error
            : null
        "
        :autocomplete="$lang.evidence_caption_third_person"
        :rows="this.$config.form.textareaRows"
      ></b-form-textarea>
      <b-form-invalid-feedback id="father_name-feedback"
        >{{
          $lang.error_required | replace($lang.evidence_caption_third_person)
        }}
      </b-form-invalid-feedback>
    </b-form-group>

    <b-form-group
      :label="$lang.caption_imperative"
      label-for="evidence"
      :label-cols="this.$config.form.labelCol"
    >
      <requiredComponent
        slot="label"
        :label="$lang.evidence_caption_imperative"
        :rules="$v.caption_imperative.$params"
      />
      <b-form-textarea
        id="evidence"
        type="text"
        v-model="$v.caption_imperative.$model"
        :state="
          $v.caption_imperative.$dirty ? !$v.caption_imperative.$error : null
        "
        :autocomplete="$lang.caption_imperative"
        :rows="this.$config.form.textareaRows"
      ></b-form-textarea>
      <b-form-invalid-feedback id="father_name-feedback"
        >{{ $lang.error_required | replace($lang.evidence_caption_imperative) }}
      </b-form-invalid-feedback>
    </b-form-group>

    <b-form-group
      :label="$lang.sample_evidence"
      label-for="evidence"
      :label-cols="this.$config.form.labelCol"
    >
      <requiredComponent
        slot="label"
        :label="$lang.sample_evidence"
        :rules="$v.sample.$params"
      />
      <b-form-textarea
        id="sample"
        type="text"
        v-model="$v.sample.$model"
        :state="$v.sample.$dirty ? !$v.sample.$error : null"
        :autocomplete="$lang.sample"
        :rows="this.$config.form.textareaRows"
      ></b-form-textarea>
      <b-form-invalid-feedback id="father_name-feedback"
        >{{ $lang.error_required | replace($lang.sample_evidence) }}
      </b-form-invalid-feedback>
    </b-form-group>
    <div class="float-right">
      <b-button
        class="ml-1"
        variant="success"
        :disabled="isdisabled || (!isEditable && !isScoreEditable)"
        @click="submit()"
      >
        {{ $lang.submitButton }}
        <i class="fa fa-check"></i>
      </b-button>

      <b-button class="ml-1" variant="danger" @click="cancelEvidance">
        {{ $lang.cancelButton }}
        <i class="fa fa-ban"></i>
      </b-button>
    </div>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";

export default {
  name: "evidence-form",
  validations: {
    evidence: {
      required,
    },
    status: {
      required,
    },
    sample: {},
    caption_imperative: {},
    caption_third_person: {},
  },
  props: {
    item: {
      type: Object,
      default: () => {},
    },
    mode: {
      type: String,
      default: "add",
    },
    isdisabled: {
      type: Boolean,
      default: false,
    },
    isScoreEditable: {
      type: Boolean,
      default: false,
    },
    isEditable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      caption_imperative: null,
      caption_third_person: null,
      evidence: null,
      status: 2,
      status_options: [],
      sample: null,
    };
  },
  methods: {
    submit() {
      let payload = {
        error_description: null,
        error_code: null,
        evidence: this.evidence,
        caption_imperative: this.caption_imperative,
        caption_third_person: this.caption_third_person,
        status: this.status,
        sample: this.sample,
      };
      this.$emit("submit", payload);
    },
    cancelEvidance() {
      this.$emit("cancel", false);
      this.$emit("modal-close", false);
    },
    getEvidenceStatus() {
      return this.$httpService
        .get(
          this.$config.api_url + this.$config.metaData.enum + "/evidence_level"
        )
        .then((response) => {
          let data = response.data.data;
          let data_status_options = [];
          data_status_options = data.map((x) => {
            return {
              value: x.enum_id,
              text: x.enum_caption,
            };
          });
          this.status_options = data_status_options;
        })
        .catch((error) => this.$generateError(error));
    },
    fetchData() {
      if (this.mode == "edit") {
        this.evidence = this.item ? this.item.evidence : null;
        this.getEvidenceStatus().then(() => {
          this.status = this.item
            ? this.status_options.find((x) => x.text == this.item.status).value
            : null;
        });
      } else {
        this.getEvidenceStatus();
      }
    },
  },
  created() {
    this.fetchData();
  },
  watch: {
    item() {
      if (this.item) {
        this.evidence = this.item.evidence;
        this.caption_third_person = this.item.caption_third_person;
        this.caption_imperative = this.item.caption_imperative;
        this.status = this.status_options.find(
          (x) => x.value == this.item.status.id
        );
      }
    },
  },
};
</script>
